export default __webpack_public_path__ + "static/media/Pessoa_fisica_on_light_blue.f09800fa.svg";